<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn color="success" class="button-shadow mr-2" @click="isFindReport=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/financereport/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="transactions.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" sm="12" md="12" lg="12" >
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px; vertical-align: top;"><img v-if="logo!=null" :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table v-if="data!=null" style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Start Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(data.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">End Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(data.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                         </table> 
                      </td>
                    </tr>
                  </table>
                  <table style="width: 100%; padding-bottom: 10px;">
                    <tr>
                      <td>
                        <div align="center" style="padding: 0; line-height: 0;"><h3><b>Stock Movement Report</b></h3></div>
                        <p align="center" style="padding: 0; line-height: 0;">
                          Period:
                          {{ new Date(data.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}&nbsp;- 
                          {{ new Date(data.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                        </p>
                      </td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </table>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                  <tbody>
                    <tr>
                      <th :style="css['row-bottom-left']">ITEM</th>
                      <th :style="css['row-bottom-right']" width="15%">Opening</th>
                      <th :style="css['row-bottom-right']" width="15%">Sold</th>
                      <th :style="css['row-bottom-right']" width="15%">Purchased</th>
                      <th :style="css['row-bottom-right']" width="15%">Other</th>
                      <th :style="css['row-bottom-right']" width="15%">Ending</th>
                    </tr>
                  </tbody>
                  <tbody v-if="data_items.length!=0">
                    <tr v-for="(trans) in data_items"  v-bind:key="trans._id">
                        <td :style="css['row-left']"> {{ trans.itemname }}</td>
                        <td :style="css['row-right']">
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getOpeningQuantity(trans.itemid).toFixed(1)  }} Qty</p>
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getOpeningAmount(trans.itemid).toFixed(1)  }}</p>
                        </td>
                        <td :style="css['row-right']">                            
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getItemQuantity(trans.itemid, 'current', 'Sales').toFixed(1)  }} Qty</p>
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getItemAmount(trans.itemid, 'current', 'Sales').toFixed(1)  }}</p>
                        </td>
                        <td :style="css['row-right']">                            
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getItemQuantity(trans.itemid, 'current', 'Purchases').toFixed(1)  }} Qty</p>
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getItemAmount(trans.itemid, 'current', 'Purchases').toFixed(1)  }}</p>
                        </td>
                        <td :style="css['row-right']">                            
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getItemQuantity(trans.itemid, 'current', 'Other').toFixed(1)  }} Qty</p>
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getItemAmount(trans.itemid, 'current', 'Other').toFixed(1)  }}</p>
                        </td>
                        <td :style="css['row-right']">                            
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getEndingQuantity(trans.itemid).toFixed(1)  }} Qty</p>
                          <p style="margin-top: 0; margin-bottom: 0;">{{ getEndingAmount(trans.itemid).toFixed(1)  }}</p>
                        </td>
                      </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 10px">&nbsp;</p>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                  <tbody>
                    <tr>
                      <th :style="css['row-bottom-left']">SUMMARY</th>
                      <th :style="css['row-bottom-right']" width="30%">Quantity</th>
                      <th :style="css['row-bottom-right']" width="30%">Amount</th>
                    </tr>
                  </tbody>
                  <tbody v-if="data_items.length!=0">
                    <tr>
                      <td :style="css['row-left']">Opening Balance</td>
                      <td :style="css['row-right']"> {{ data_opening_quantity.toFixed(1) }}</td>
                      <td :style="css['row-right']"> {{ data_opening_amount.toFixed(1) }}</td>
                    </tr>
                    <tr>
                      <td :style="css['row-left']">Products Sales</td>
                      <td :style="css['row-right']">{{ data_sales_quantity.toFixed(1) }}</td>
                      <td :style="css['row-right']">{{ data_sales_amount.toFixed(1) }}</td>
                    </tr>
                    <tr>
                      <td :style="css['row-left']">Products Purchases</td>
                      <td :style="css['row-right']">{{ data_purchases_quantity.toFixed(1) }}</td>
                      <td :style="css['row-right']">{{ data_purchases_amount.toFixed(1) }}</td>
                    </tr>
                    <tr>
                      <td :style="css['row-left']">Other Adjustments</td>
                      <td :style="css['row-right']">{{ data_other_quantity.toFixed(1) }}</td>
                      <td :style="css['row-right']">{{ data_other_amount.toFixed(1) }}</td>
                    </tr>
                    <tr>
                      <td :style="css['row-left-end']">Ending Balance</td>
                      <td :style="css['row-right-end']">{{ data_ending_quantity.toFixed(1) }}</td>
                      <td :style="css['row-right-end']">{{ data_ending_amount.toFixed(1) }}</td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div>
    <v-dialog
      v-model="isFindReport"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_startdate"
                  v-model="menu_startdate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.startdate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.startdate"
                      label="Start Date"
                      v-bind="attrs"
                      v-bind:value="find_query.startdate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter start date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.startdate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_startdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_startdate.save(find_query.startdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.enddate"
                      label="End Date"
                      v-bind="attrs"
                      v-bind:value="find_query.enddate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter end date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.enddate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_enddate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_enddate.save(find_query.enddate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindReport = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetReport"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
    import {mapActions} from "vuex";
    import { getLogo, formatStdDate } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            logo: null,
            isFindReport: false,
            menu_startdate: null,
            menu_enddate: null,
            companycode: null,
            reportname: 'Stock_Movement', 
            digits: null,
            find_query: {},
            data: {},
            transactions: [],
            css: {
              'row-top-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: solid;',
              'row-top-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: solid; font-weight: bold;',
              'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
              'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
              'row-left': 'font-size: 10pt; text-align: left; padding: 5px; vertical-align: top; border-bottom: 1px; border-bottom-style: solid;',
              'row-right': 'font-size: 10pt; text-align: right; padding: 5px;border-bottom: 1px; border-bottom-style: solid;',
              'row-left-end': 'font-size: 10pt; text-align: left; padding: 5px; vertical-align: top; border-top: 2px; border-top-style: solid;',
              'row-right-end': 'font-size: 10pt; text-align: right; padding: 5px;border-top: 2px; border-top-style: solid;',
            },
            formatStdDate: formatStdDate,
          };
        },
        computed: {
          data_items(){
            let results = [];
            let filter = this.transactions.filter(item=>item.itemid!=null);
            let object = Object.groupBy(filter, item => { return item.itemid});
          
            for (var key of Object.keys(object)) {
              let result = {itemid: key, itemname: this.getItemName(key)}
              results.push(result);
            }
            return results
          },
          data_opening_quantity(){
            let filter = this.transactions.filter(x=>x['period']=='previous');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseQty - b.decreaseQty), 0);
            return result;
          },
          data_opening_amount(){
            let filter = this.transactions.filter(x=>x['period']=='previous');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseAmount - b.decreaseAmount), 0);
            return result;
          },
          data_sales_quantity(){
            let filter = this.transactions.filter(x=>x['period']=='current' && x['class']=='Sales');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseQty - b.decreaseQty), 0);
            return result;
          },
          data_sales_amount(){
            let filter = this.transactions.filter(x=>x['period']=='current' && x['class']=='Sales');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseAmount - b.decreaseAmount), 0);
            return result;
          },
          data_purchases_quantity(){
            let filter = this.transactions.filter(x=>x['period']=='current' && x['class']=='Purchases');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseQty - b.decreaseQty), 0);
            return result;
          },
          data_purchases_amount(){
            let filter = this.transactions.filter(x=>x['period']=='current' && x['class']=='Purchases');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseAmount - b.decreaseAmount), 0);
            return result;
          },
          data_other_quantity(){
            let filter = this.transactions.filter(x=>x['period']=='current' && x['class']=='Other');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseQty - b.decreaseQty), 0);
            return result;
          },
          data_other_amount(){
            let filter = this.transactions.filter(x=>x['period']=='current' && x['class']=='Other');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseAmount - b.decreaseAmount), 0);
            return result;
          },
          data_ending_quantity(){
            let result = this.data_opening_quantity+this.data_sales_quantity+this.data_purchases_quantity+this.data_other_quantity;
            return result;
          },
          data_ending_amount(){
            let result = this.data_opening_amount+this.data_sales_amount+this.data_purchases_amount+this.data_other_amount;
            return result;
          },
        },
        methods: {
          ...mapActions('FinanceReport', ["setReport", "findFinanceReportStockMovementRequest", "getFinanceReportStockMovementRequest"]),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html>');
            mywindow.document.write('<head><title>'+ `${this.companycode} ${this.reportname} ${ this.formatStdDate(this.data.startdate) }_${ this.formatStdDate(this.data.enddate) }` + '</title></head>');
            mywindow.document.write('<body onclick="window.print();">');  
            mywindow.document.write(content);
            mywindow.document.write('</body>');
            mywindow.document.write('</html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          getSign(value){
            if(value<0) return '-';
            else if(value>0) return '+';
            return '';
          },
          getOpeningAmount(itemid){
            let filter = this.transactions.filter(x=>x['itemid']==itemid && x['period']=='previous');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseAmount - b.decreaseAmount), 0);
            return result;
          },
          getOpeningQuantity(itemid){
            let filter = this.transactions.filter(x=>x['itemid']==itemid && x['period']=='previous');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseQty - b.decreaseQty), 0);
            return result;
          },
          getCurrentAmount(itemid){
            let filter = this.transactions.filter(x=>x['itemid']==itemid && x['period']=='current');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseAmount - b.decreaseAmount), 0);
            return result;
          },
          getCurrentQuantity(itemid){
            let filter = this.transactions.filter(x=>x['itemid']==itemid && x['period']=='current');
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseQty - b.decreaseQty), 0);
            return result;
          },
          getEndingAmount(itemid){
            let result = this.getOpeningAmount(itemid)+this.getCurrentAmount(itemid);
            return result;
          },
          getEndingQuantity(itemid){
            let result = this.getOpeningQuantity(itemid)+this.getCurrentQuantity(itemid);
            return result;
          },
          getItemName(itemid){
            let result = this.transactions.find(x=>x.itemid==itemid);
            return result['itemname'];
          },
          getItemAmount(itemid, item_period, item_class){
            let filter = this.transactions.filter(x=>x['itemid']==itemid && x['period']==item_period && x['class']==item_class);
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseAmount - b.decreaseAmount), 0);
            return result;
          },
          getItemQuantity(itemid, item_period, item_class){
            let filter = this.transactions.filter(x=>x['itemid']==itemid && x['period']==item_period && x['class']==item_class);
            let result = filter.reduce((a, b) => a + parseFloat(b.increaseQty - b.decreaseQty), 0);
            return result;
          },

          resetReport(){
            this.find_query = {};
          },
          async findReport(){
            this.data = await this.findFinanceReportStockMovementRequest(this.find_query);
            this.transactions = Object.assign([], this.data.transactions);
            this.isFindReport = false;
          },
          getFileName(){
            var name = `${this.companycode} Stock_Movement` + ' ' + `${formatStdDate(this.data.startdate)} - ${formatStdDate(this.data.enddate)}` ;
            return name + '.xls';
          },
          getJson(){
            let jsons = [];
            let items = this.data_items;
            for(var item of items){
              let json = {
                itemname: item.itemname,
                startdate: this.formatStdDate(this.data.startdate),
                enddate: this.formatStdDate(this.data.enddate),
                opening_quantity: this.getOpeningQuantity(item.itemid).toFixed(1),
                opening_amount: this.getOpeningAmount(item.itemid).toFixed(1),
                sales_quantity: this.getItemQuantity(item.itemid, 'current', 'Sales').toFixed(1),
                sales_amount: this.getItemAmount(item.itemid, 'current', 'Sales').toFixed(1),
                purchases_quantity: this.getItemQuantity(item.itemid, 'current', 'Purchases').toFixed(1),
                purchases_amount: this.getItemAmount(item.itemid, 'current', 'Purchases').toFixed(1),
                other_quantity: this.getItemQuantity(item.itemid, 'current', 'Other').toFixed(1),
                other_amount: this.getItemAmount(item.itemid, 'current', 'Other').toFixed(1),
                ending_quantity: this.getEndingQuantity(item.itemid).toFixed(1),
                ending_amount: this.getEndingAmount(item.itemid).toFixed(1),
              }
              jsons.push(json);
            }
            return jsons;
          },
        },
        async created () {
          this.data = await this.getFinanceReportStockMovementRequest();
          this.transactions = Object.assign([], this.data.transactions);
          var companyid = localStorage.getItem("companyid");
          this.companycode = localStorage.getItem("companycode");
          this.logo = getLogo(companyid);
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
